import { Alert } from '../../types';

export const checkForActiveAlerts = (alerts: {[index: number]: Alert[]}) => {
  if(alerts) {
    let cleared: number = 0;
    let notCleared: number = 0;
    Object.keys(alerts).forEach((key) => {
      if(alerts[key]) {
        alerts[key].forEach((alert: Alert) => {
          if(alert.cleared) {
            cleared = cleared + 1;
          } else {
            notCleared = notCleared + 1;
          }
        })
      }
    })
    return notCleared > 0 ? true : false;
  } else return 0;
}






// WEBPACK FOOTER //
// ./src/utils/alerts/checkForActiveAlerts.ts